export default __webpack_public_path__ + "static/media/SPECTRAL KRIK KROK.a1cf7426.jpg";